module.exports = __webpack_public_path__ + "img/res2-m.d5049bee.png";